module.exports = __webpack_public_path__ + "static/media/kids_61.6422eb3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_61.jpg
// module id = 5916
// module chunks = 0